export default __webpack_public_path__ + "static/media/guia-2-2.d6ae74af.svg";